// extracted by mini-css-extract-plugin
module.exports = {"container":"aP","centerMenu":"aQ","mainPanel":"aR","actions":"aS","logo":"aT"};